import React, { useState, useEffect } from 'react';
import PopularBanksView from './popularBanksView';
import SelectBankView from './selectBankView';
import SelectBranchView from './selectBranchView';
import BankConfirmView from './bankConfirmView';
import BankClient from '../../../common/models/banks/bankClient';
import type { Bank } from '../../../common/models/banks/bank';
import type { BankBranch } from '../../../common/models/banks/bankBranch';
import { handleAxiosError } from '../../../common/helpers/axiosHelper';
import { simpleFlashMessage } from '../../../common/utils/flashMessage';

export const POPULAR_BANKS_VIEW = 0;
export const SELECT_BANK_VIEW = 1;
export const SELECT_BRANCH_VIEW = 2;
export const CONFIRM_VIEW = 3;

type Props = {
  bank: Bank | null;
  branch: BankBranch | null;
  onChangeBank: (bank: Bank) => void;
  onChangeBranch: (branch: BankBranch) => void;
  onOk: () => void;
  onCancel: () => void;
};

export default function BankModalView({
  bank,
  branch,
  onChangeBank,
  onChangeBranch,
  onOk,
  onCancel,
}: Props) {
  const [banks, setBanks] = useState<Bank[]>([]);
  const [view, setView] = useState<number>(POPULAR_BANKS_VIEW);

  useEffect(() => {
    const bankClient = new BankClient();
    bankClient
      .fetchAll()
      .then(response => {
        setBanks(response.data);
      })
      .catch(error => {
        handleAxiosError(error, simpleFlashMessage);
      });
  }, []);

  const handleChangeBank = (selectedBank: Bank) => {
    onChangeBank(selectedBank);
    setView(SELECT_BRANCH_VIEW);
  };

  const handleChangeBranch = (selectedBranch: BankBranch) => {
    onChangeBranch(selectedBranch);
    setView(CONFIRM_VIEW);
  };

  const handleOk = () => {
    onOk();
    setView(POPULAR_BANKS_VIEW);
  };

  const handleCancel = () => {
    onCancel();
    setView(POPULAR_BANKS_VIEW);
  };

  return (
    <div className="modal modal-fullscreen" id="bank_modal" tabIndex={-1}>
      {view === POPULAR_BANKS_VIEW && (
        <PopularBanksView
          banks={banks}
          onTransition={setView}
          onChangeBank={handleChangeBank}
          onCancel={handleCancel}
        />
      )}
      {view === SELECT_BANK_VIEW && (
        <SelectBankView
          banks={banks}
          onTransition={setView}
          onChangeBank={handleChangeBank}
          onCancel={handleCancel}
        />
      )}
      {view === SELECT_BRANCH_VIEW && bank != null && (
        <SelectBranchView
          bank={bank}
          onTransition={setView}
          onChangeBranch={handleChangeBranch}
          onCancel={handleCancel}
        />
      )}
      {view === CONFIRM_VIEW && bank != null && branch != null && (
        <BankConfirmView
          bank={bank}
          branch={branch}
          onTransition={setView}
          onOk={handleOk}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
}
